/** API service (using axios HTTP client) */
import axios from 'axios';
import * as ENDPOINTS from './endpoints'

const BASE_URL = process.env.VUE_APP_API_BASE + '/api';


const api = axios.create({
    baseURL: BASE_URL,
});


export default {
    getModels(success, failure) {
        api.get(ENDPOINTS.MODELS_ENDPOINT)
            .then(function (response) {
                success(response.data);
            })
            .catch(function (error) {
                failure(error.toString());
            })
    },
    getOffers(params, success, failure) {
        api.get(ENDPOINTS.OFFERS_ENDPOINT, {params:params})
            .then(function (response) {
                success(response.data)
            })
            .catch(function (error) {
                failure(error.toString());
            })
    },
    getDisclaimer(id, success, failure) {
        api.get(ENDPOINTS.DISCLAIMER_ENDPOINT + '/' + id)
            .then(function (response) {
                success(response.data)
            })
            .catch(function (error) {
                failure(error.toString());
            })
    },
    getSmeDescriptions(success, failure) {
        api.get(ENDPOINTS.SME_DESCRIPTIONS_ENDPOINT)
            .then(function (response) {
                success(response.data)
            })
            .catch(function (error) {
                failure(error.toString());
            })
    },
    getVehicle(slug, success, failure) {
        api.get(ENDPOINTS.VEHICLE_ENDPOINT + '/' + slug)
            .then(function (response) {
                success(response.data)
            })
            .catch(function (error) {
                failure(error.toString());
            })
    },
    getBodyList(params, success, failure) {
        api.get(ENDPOINTS.BODY_ENDPOINT, {params: params})
            .then(function (response) {
                success(response.data)
            })
            .catch(function (error) {
                failure(error.toString());
            })
    },
    getMakes(bodyList, type, success, failure) {
        api.post(ENDPOINTS.MAKE_ENDPOINT, {bodyStyles: bodyList, type: type})
            .then(function (response) {
                success(response.data)
            })
            .catch(function (error) {
                failure(error.toString());
            })
    },
    getFuelTypes(type, success, failure) {
        api.get(ENDPOINTS.FUEL_ENDPOINT, {params: {type:type}})
            .then(function (response) {
                success(response.data)
            })
            .catch(function (error) {
                failure(error.toString());
            })
    },
    getRanges(criteria, success, failure) {
        api.post(ENDPOINTS.RANGE_ENDPOINT, criteria)
            .then(function (response) {
                success(response.data)
            })
            .catch(function (error) {
                failure(error.toString());
            })


    },
    filterFinance(params, success, failure) {
        api.post(ENDPOINTS.FILTER_ENDPOINT, params)
            .then(function (response) {
            success(response.data)
            })
            .catch(function (error) {
                failure(error.toString());
            })
    },
    prepareFilterQuery(store) {
        return {
            body: store.FILTER_BODY,
            manufacturer: store.FILTER_MANUFACTURER,
            trim: store.FILTER_MODEL,
            rental: store.FILTER_RENTAL,
            fuelType: store.FILTER_FUEL_TYPE,
            emissions: store.FILTER_CO2,
            maintenance: store.FINANCE_FILTER_MAINT,
            order: store.FILTER_ORDER,
            financeTerm: store.FINANCE_FILTER_TERM,
            financeMileage: store.FINANCE_FILTER_MILEAGE,
            financeAdvance: store.FINANCE_FILTER_ADVANCE,
            resultsPage: store.SEARCH_RESULTS_PAGE,
            resultsPerPage: store.SEARCH_RESULTS_PER_PAGE,
            type: store.FILTER_TYPE
        }
    }
}